import { ComponentOptions, IComponentBindings, Initialization } from 'coveo-search-ui';
import { AtlasComponent } from "./../models/AtlasComponent";
import * as $ from "jquery";

export class ResetFacets extends AtlasComponent {
	static ID = 'ResetFacets';
	private isLoaded = false;
	private facets : Coveo.Facet[];

	constructor(public element: HTMLElement, public options: ComponentOptions, public bindings: IComponentBindings) {
		super(element, ResetFacets.ID, bindings);
		this.options = ComponentOptions.initComponentOptions(element, ResetFacets, options);
		this.facets = $(".Coveo" + Coveo.Facet.ID).get().map((elem) => Coveo.get(elem, Coveo.Facet) as Coveo.Facet);

		// Event listeners
		this.domElement.on("click", this.resetFacets.bind(this));
	}

	protected resetFacets() {
		this.facets.forEach((facet) => facet.reset());
	}
}

Initialization.registerAutoCreateComponent(ResetFacets);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/ResetFacets.ts